import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../../components/ui/button';

const CookiesPage = () => {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-300">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <Link to="/">
          <Button variant="ghost" className="mb-6 text-zinc-400 hover:text-white">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Volver
          </Button>
        </Link>

        <h1 className="text-3xl font-bold text-white mb-2">Política de Cookies</h1>
        <p className="text-sm text-zinc-500 mb-8">Última actualización: 19 de febrero de 2026</p>

        <div className="prose prose-invert prose-zinc max-w-none space-y-8">
          
          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              3.1. Cookies Técnicas (Necesarias)
            </h2>
            <p>Se utilizan cookies técnicas necesarias para:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Gestión de la sesión del usuario.</li>
              <li>Seguridad de la plataforma.</li>
              <li>Acceso a áreas privadas y funcionamiento básico del servicio.</li>
            </ul>
            <div className="mt-4 p-4 bg-zinc-900/50 rounded-lg">
              <p className="text-sm text-zinc-400">
                Estas cookies no requieren consentimiento, al amparo del artículo 22.2 de la LSSI.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              3.2. Cookies Analíticas (Opcionales)
            </h2>
            <p>
              Se podrán utilizar cookies analíticas (por ejemplo, Google Analytics u otras herramientas similares) 
              con el fin de obtener estadísticas de uso y mejorar la plataforma.
            </p>
            <div className="mt-4 p-4 bg-primary/10 border border-primary/20 rounded-lg">
              <p className="text-primary text-sm">
                <strong>Importante:</strong> Estas cookies requieren el consentimiento expreso del usuario y solo 
                se instalarán si las acepta de forma previa a través del banner o panel de configuración de cookies.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              3.3. Gestión del Consentimiento
            </h2>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Se mostrará un banner de cookies en el primer acceso a la plataforma.</li>
              <li>El usuario podrá configurar en cualquier momento sus preferencias de cookies, aceptando o rechazando las cookies no necesarias.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              3.4. Cookies de Terceros
            </h2>
            <p>
              En caso de utilizarse cookies de terceros (por ejemplo, proveedores de analítica), se facilitará 
              información sobre dichos terceros y enlaces a sus políticas de privacidad y cookies en el propio 
              panel de configuración cuando se implementen.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              3.5. Bloqueo desde el Navegador
            </h2>
            <p>
              El usuario puede configurar su navegador para bloquear o eliminar cookies, normalmente desde 
              los apartados de "Privacidad" o "Seguridad".
            </p>
            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="p-4 bg-zinc-900/50 rounded-lg">
                <p className="font-semibold text-zinc-200 mb-2">Chrome</p>
                <p className="text-sm text-zinc-400">Configuración → Privacidad y seguridad → Cookies</p>
              </div>
              <div className="p-4 bg-zinc-900/50 rounded-lg">
                <p className="font-semibold text-zinc-200 mb-2">Firefox</p>
                <p className="text-sm text-zinc-400">Opciones → Privacidad → Historial</p>
              </div>
              <div className="p-4 bg-zinc-900/50 rounded-lg">
                <p className="font-semibold text-zinc-200 mb-2">Safari</p>
                <p className="text-sm text-zinc-400">Preferencias → Privacidad</p>
              </div>
              <div className="p-4 bg-zinc-900/50 rounded-lg">
                <p className="font-semibold text-zinc-200 mb-2">Edge</p>
                <p className="text-sm text-zinc-400">Configuración → Cookies y permisos del sitio</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              3.6. Datos de Categorías Especiales
            </h2>
            <p>
              A través de la plataforma se tratan datos relacionados con la condición física y hábitos de 
              actividad del usuario, considerados de categorías especiales a efectos de protección de datos.
            </p>
            <p className="mt-4">
              Estas cookies y tecnologías similares solo se utilizarán en la medida estrictamente necesaria 
              para la prestación del servicio y siempre de acuerdo con lo establecido en la Política de Privacidad 
              de GUARDIÁNSFIT, con las garantías adicionales de seguridad, confidencialidad y consentimiento 
              informado que allí se describen.
            </p>
          </section>

        </div>

        <div className="mt-12 pt-8 border-t border-zinc-800">
          <p className="text-sm text-zinc-500 text-center">
            © 2026 GUARDIÁNSFIT - Todos los derechos reservados
          </p>
        </div>
      </div>
    </div>
  );
};

export default CookiesPage;
